export interface CampaignSummary {
  id: number;
  uuid: string;
  tenantId: number;
  projectId: number;
  projectName: string;
  areaPilotoId: number | null;
  areaPilotoName: string | null;
  code: string;
  name: string;
  campaignType: string;
  status: string;
  description: string | null;
  startDate: string | null;
  endDate: string | null;
  targetTreeCount: number | null;
  notes: string | null;
  createdAt: string;
  updatedAt: string;
  memberCount: number;
  quadraCount: number;
  quadrasConcluidas: number;
  registeredTreeCount: number;
  progressPercent: number;
}

export interface CampaignMember {
  id: number;
  campaignId: number;
  userId: number | null;
  partyId: number | null;
  memberRole: string;
  memberName: string | null;
  professionalCouncil: string | null;
  professionalRegistration: string | null;
  isActive: boolean;
  joinedAt: string;
}

export interface CampaignQuadraProgress {
  id: number;
  campaignId: number;
  campaignCode: string;
  campaignName: string;
  quadraId: number;
  quadraCode: string;
  quadraName: string | null;
  status: string;
  targetTreeCount: number | null;
  registeredTreeCount: number;
  startedAt: string | null;
  completedAt: string | null;
  notes: string | null;
  progressPercent: number;
}

export interface TreeCreateResult {
  id: number;
  uuid: string;
  ctaCode: string;
  status: string;
  duplicateOf: number | null;
  isNew: boolean;
}

export const CAMPAIGN_TYPE_LABELS: Record<string, string> = {
  IMPLANTACAO_CTA: "Implantação CTA",
  INVENTARIO: "Inventário",
  MONITORAMENTO: "Monitoramento",
  LEVANTAMENTO_COMPLEMENTAR: "Levantamento Complementar",
  REMONITORAMENTO: "Remonitoramento",
  EMERGENCIAL: "Emergencial",
};

export const CAMPAIGN_STATUS_LABELS: Record<string, string> = {
  PLANEJADA: "Planejada",
  EM_ANDAMENTO: "Em Andamento",
  PAUSADA: "Pausada",
  CONCLUIDA: "Concluída",
  CANCELADA: "Cancelada",
};

export const CAMPAIGN_STATUS_COLORS: Record<string, string> = {
  PLANEJADA: "bg-blue-100 text-blue-700",
  EM_ANDAMENTO: "bg-green-100 text-green-700",
  PAUSADA: "bg-yellow-100 text-yellow-700",
  CONCLUIDA: "bg-gray-100 text-gray-600",
  CANCELADA: "bg-red-100 text-red-700",
};

export const MEMBER_ROLE_LABELS: Record<string, string> = {
  COORDENADOR: "Coordenador",
  TECNICO: "Técnico",
  AUXILIAR: "Auxiliar",
  SUPERVISOR: "Supervisor",
  MOTORISTA: "Motorista",
};
